
import {ProcessConfiguration} from "../config/process-configuration";
import {Project} from "../models/project";

export class ProjectProcessFilter {

    /**
     * Apply process filters
     * @param projects
     * @param filters
     */
    static apply(projects: Project[], filters: string[]): Project[] {
        if (!filters || filters.length === 0) {
            return projects;
        }
        // check if process filters included
        if (!filters.some((f) => f.includes("status-"))) {
            // no process filters
            return projects;
        }

        return projects.filter((a: Project) => {
            if (!a.process || !a.process.config) {
                // do not return projects without process or process config when filtering for process status
                return false;
            }
            const config: ProcessConfiguration = a.process.config;
            const key = `status-${config.id}-${config.version}-${a.process.statusId}`;
            // show activity when filter key matches
            return filters.includes(key);
        });
    }
}
